import React from "react"
import Breadcrumbs from "./ui/Breadcrumbs"

/**
 * Breadcrumbs Section Component
 * Displays breadcrumb navigation with proper styling
 */
const BreadcrumbsSection = ({ items = [] }) => {
  return (
    <div className="flex-shrink-0">
      <div className="w-full max-w-w2_xl flex items-center py-5 md:py-9 lg:py-12 xl:py-14 mx-auto">
        <Breadcrumbs items={items} />
      </div>
    </div>
  )
}

export default BreadcrumbsSection
